import type { SiteBrand } from '~/config/branding';

export type LandingContent = {
  /** Headline rendered as stacked lines (joined by <br />). */
  headline: string[];
  subheadline: string;
  description: string;
};

// Per-brand landing copy. MedCredVault leads with the provider-owned credential
// vault; HealthcareLX leads with the two-sided healthcare labor-exchange
// marketplace (providers + organizations). [MCV-1490]
export const LANDING_CONTENT: Record<SiteBrand, LandingContent> = {
  mcv: {
    headline: ['Own Your Credentials', 'Control Your Career'],
    subheadline: 'A Free, Secure, AI-powered Vault Built For Every Provider',
    description: 'Manage credentialing, compliance, and career insights—all in one place.',
  },
  hlx: {
    headline: ['Connecting People.', 'Powering Care.'],
    subheadline:
      'The AI-assisted healthcare labor exchange linking providers with the organizations that need them.',
    description:
      'Find your next opportunity or hire qualified, credential-ready providers—all in one place.',
  },
};
